import React from 'react'
import { Container, Header } from '../../components_renew/Layout'

// src只能是htm而不能是html
export class FramePage extends React.PureComponent {
  componentDidMount () {
    window.toast.loading()
  }

  render () {
    const { src, title, hideTitle } = this.props
    return <Container>
      {hideTitle ? null : <Header>{title}</Header>}
      <iframe
        style={{
          flex: '1 1 auto',
          border: 'none',
          width: '100%',
          height: '100%',
          backgroundColor: 'white',
          // 改不了字体颜色...，只能白底黑字
          // color: 'var(--adm-color-text)',
          // background: 'var(--adm-color-background)'
        }}
        title={'frame'}
        src={src}
        onLoad={this.onLoad}
      />
      {window.appInfo['REACT_APP_BUILD_ENV'] === 'development' && <div>{src}</div>}
    </Container>
  }

  onLoad = () => {
    window.toast.hide()
  }
}
